(() => {
  angular
    .module('gm.common.constants')
    .constant('Timezones', [
      {
        offset: -720,
        name: 'International Date Line West'
      },
      {
        offset: -660,
        name: 'Midway Island, Samoa'
      },
      {
        offset: -600,
        name: 'Hawaii'
      },
      {
        offset: -540,
        name: 'Alaska'
      },
      {
        offset: -480,
        name: 'Pacific Time (US & Canada)'
      },
      {
        offset: -480,
        name: 'Tijuana, Baja California'
      },
      {
        offset: -420,
        name: 'Arizona'
      },
      {
        offset: -420,
        name: 'Chihuahua, La Paz, Mazatlan'
      },
      {
        offset: -420,
        name: 'Mountain Time (US & Canada)'
      },
      {
        offset: -360,
        name: 'Central America'
      },
      {
        offset: -360,
        name: 'Central Time (US & Canada)'
      },
      {
        offset: -360,
        name: 'Guadalajara, Mexico City, Monterrey'
      },
      {
        offset: -360,
        name: 'Saskatchewan'
      },
      {
        offset: -300,
        name: 'Bogota, Lima, Quito, Rio Branco'
      },
      {
        offset: -300,
        name: 'Eastern Time (US & Canada)'
      },
      {
        offset: -300,
        name: 'Indiana (East)'
      },
      {
        offset: -240,
        name: 'Atlantic Time (Canada)'
      },
      {
        offset: -240,
        name: 'Caracas, La Paz'
      },
      {
        offset: -240,
        name: 'Manaus'
      },
      {
        offset: -240,
        name: 'Santiago'
      },
      {
        offset: -210,
        name: 'Newfoundland'
      },
      {
        offset: -180,
        name: 'Brasilia'
      },
      {
        offset: -180,
        name: 'Buenos Aires, Georgetown'
      },
      {
        offset: -180,
        name: 'Greenland'
      },
      {
        offset: -180,
        name: 'Montevideo'
      },
      {
        offset: -120,
        name: 'Mid-Atlantic'
      },
      {
        offset: -60,
        name: 'Cape Verde Is.'
      },
      {
        offset: -60,
        name: 'Azores'
      },
      {
        offset: 0,
        name: 'Casablanca, Monrovia, Reykjavik'
      },
      {
        offset: 0,
        name: 'Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London'
      },
      {
        offset: 60,
        name: 'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna'
      },
      {
        offset: 60,
        name: 'Belgrade, Bratislava, Budapest, Ljubljana, Prague'
      },
      {
        offset: 60,
        name: 'Brussels, Copenhagen, Madrid, Paris'
      },
      {
        offset: 60,
        name: 'Sarajevo, Skopje, Warsaw, Zagreb'
      },
      {
        offset: 60,
        name: 'West Central Africa'
      },
      {
        offset: 120,
        name: 'Amman'
      },
      {
        offset: 120,
        name: 'Athens, Bucharest, Istanbul'
      },
      {
        offset: 120,
        name: 'Beirut'
      },
      {
        offset: 120,
        name: 'Cairo'
      },
      {
        offset: 120,
        name: 'Harare, Pretoria'
      },
      {
        offset: 120,
        name: 'Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius'
      },
      {
        offset: 120,
        name: 'Jerusalem'
      },
      {
        offset: 120,
        name: 'Minsk'
      },
      {
        offset: 120,
        name: 'Windhoek'
      },
      {
        offset: 180,
        name: 'Kuwait, Riyadh, Baghdad'
      },
      {
        offset: 180,
        name: 'Moscow, St. Petersburg, Volgograd'
      },
      {
        offset: 180,
        name: 'Nairobi'
      },
      {
        offset: 180,
        name: 'Tbilisi'
      },
      {
        offset: 210,
        name: 'Tehran'
      },
      {
        offset: 240,
        name: 'Abu Dhabi, Muscat'
      },
      {
        offset: 240,
        name: 'Baku'
      },
      {
        offset: 240,
        name: 'Yerevan'
      },
      {
        offset: 270,
        name: 'Kabul'
      },
      {
        offset: 300,
        name: 'Yekaterinburg'
      },
      {
        offset: 300,
        name: 'Islamabad, Karachi, Tashkent'
      },
      {
        offset: 330,
        name: 'Sri Jayawardenapura'
      },
      {
        offset: 330,
        name: 'Chennai, Kolkata, Mumbai, New Delhi'
      },
      {
        offset: 345,
        name: 'Kathmandu'
      },
      {
        offset: 360,
        name: 'Almaty, Novosibirsk'
      },
      {
        offset: 360,
        name: 'Astana, Dhaka'
      },
      {
        offset: 390,
        name: 'Yangon (Rangoon)'
      },
      {
        offset: 420,
        name: 'Bangkok, Hanoi, Jakarta'
      },
      {
        offset: 420,
        name: 'Krasnoyarsk'
      },
      {
        offset: 480,
        name: 'Beijing, Chongqing, Hong Kong, Urumqi'
      },
      {
        offset: 480,
        name: 'Kuala Lumpur, Singapore'
      },
      {
        offset: 480,
        name: 'Irkutsk, Ulaan Bataar'
      },
      {
        offset: 480,
        name: 'Perth'
      },
      {
        offset: 480,
        name: 'Taipei'
      },
      {
        offset: 540,
        name: 'Osaka, Sapporo, Tokyo'
      },
      {
        offset: 540,
        name: 'Seoul'
      },
      {
        offset: 540,
        name: 'Yakutsk'
      },
      {
        offset: 570,
        name: 'Adelaide'
      },
      {
        offset: 570,
        name: 'Darwin'
      },
      {
        offset: 600,
        name: 'Brisbane'
      },
      {
        offset: 600,
        name: 'Canberra, Melbourne, Sydney'
      },
      {
        offset: 600,
        name: 'Hobart'
      },
      {
        offset: 600,
        name: 'Guam, Port Moresby'
      },
      {
        offset: 600,
        name: 'Vladivostok'
      },
      {
        offset: 660,
        name: 'Magadan, Solomon Is., New Caledonia'
      },
      {
        offset: 720,
        name: 'Auckland, Wellington'
      },
      {
        offset: 720,
        name: 'Fiji, Kamchatka, Marshall Is.'
      },
      {
        offset: 780,
        name: 'Nuku\'alofa'
      }
    ]);
})();
